import Vue from 'vue'

const bus = new Vue()

export const EventBus = {
    subscribe(eventName, callback) {
        if (!callback) {
            throw 'callback must be provided'
        }
        bus.$on(eventName, callback)
    },
    unsubscribe(eventName, callback) {
        if (!callback) {
            throw 'callback must be provided'
        }
        bus.$off(eventName, callback)
    },
    publish(eventName, payload) {
        bus.$emit(eventName, payload)
    },
}
